import { KeyValuePair } from '../../../../models/key-value-pair';

export class DriveItemPermissionRemovalDetailModel {
  driveItemId: string;
  listItemId: string;
  permissionIds: KeyValuePair[];
  name: string;
  path: string;
}
